module.exports = __webpack_public_path__ + "img/logo.abf51601.png";